import { render } from "./Hidden.vue?vue&type=template&id=0830c9eb&lang=pug"
import script from "./Hidden.vue?vue&type=script&lang=js"
export * from "./Hidden.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__